import { useInviteMemberMutation } from '@/queries/organizations.queries';
import { useToast } from '@chakra-ui/react';
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { object, string } from 'yup';

interface IArgs {
	organizationId: string;
	isOpen: boolean;
	close: () => void;
}

export function useAddMemberModal(args: IArgs) {
	const toast = useToast();
	const { t } = useTranslation();
	const inviteMemberMutation = useInviteMemberMutation();

	const form = useForm({
		defaultValues: {
			email: '',
			roles: 'MEMBER',
		},
		resolver: yupResolver(
			object().shape({
				email: string().email().required(),
				roles: string().required(),
			})
		),
	});

	const handleSubmit = form.handleSubmit((values) => {
		return inviteMemberMutation
			.mutateAsync({
				organizationId: args.organizationId,
				email: values.email,
				roles: [values.roles],
			})
			.then(() => {
				form.reset();
				args.close();
				toast({
					isClosable: true,
					title: t('Member invited'),
					description: t('Once the member accepts the invitation, they will be able to access the organization.'),
					status: 'success',
				});
			})
			.catch((err) => {
				switch (err.response.status) {
					case 404:
						return toast({
							isClosable: true,
							title: t('The email is not associated to a TimeTime account.'),
							description: t('Please ask {{email}} to create an account.', { email: values.email }),
							status: 'error',
						});
					default:
						toast({
							isClosable: true,
							title: t('Error'),
							description: t(
								'This is usually a network error, please try again and if the problem persists contact support.'
							),
							status: 'error',
						});
				}
			});
	});

	return { form, handleSubmit, t };
}
